// import ModalManager from '../modal/ModalManager'
// import $ from 'jquery'
import _ from 'lodash'
import Vue from 'vue'
import MessageBox from './MessageBox'
import { DefaultIconMap } from './constants'
import { document } from 'ssr-window'

const MessageBoxConstructor = Vue.extend(MessageBox)

// 用于挂载vue.use的扩展参数
export const extend = {}

/**
 * 消息框管理器
 *
 * 针对并发 Modal(MessageBox)
 * a 顺序性 - 保证只能有一个消息框处理激活状态
 * b 唯一性 - 相同 id 消息框只有第一个生效
 */
const manager = new Vue({
  data: {
    queue: [],
  },
  computed: {},
  watch: {
    queue() {
      const meta = _.head(this.queue)
      if (!meta) {
        return
      }
      const { resolve, reject, options } = meta
      const instance = new MessageBoxConstructor({
        el: document.createElement('div'),
        data() {
          return {
            ...options,
          }
        },
      })

      instance.$on('action', (action) => {
        instance.visible = false

        this.queue.shift()

        // ok：点击确定按钮；
        // cancel：点击取消按钮；
        // close： 其余的关闭操作。
        if (action === 'ok') {
          resolve()
        } else if (action === 'cancel' || action === 'close') {
          reject({ action, trigger: 'kamalaMessage' })
        }
      })

      instance.visible = true
    },
  },
  methods: {
    createMsgBox(options) {
      const uniqueKey = options.uniqueKey
      const meta = uniqueKey && _.find(this.queue, ['uniqueKey', uniqueKey])
      if (meta) {
        return new Promise((resolve, reject) => {
          reject(`Message box with uniqueKey: ${uniqueKey} has exists`)
        })
      }

      delete options.uniqueKey

      return new Promise((resolve, reject) => {
        this.queue.push({
          uniqueKey,
          options,
          resolve,
          reject,
        })
      })
    },
  },
})

export const getDefaultIcon = function (type) {
  const iconMap = _.assign({}, DefaultIconMap, extend.icons)
  return iconMap[type] || iconMap.primary
}

//
export default {
  name: 'KMessageBox',
  msgBox(options) {
    return manager.createMsgBox(options)
  },
  /**
   * API - alert
   * @param options
   */
  alert(options) {
    options = _.assign(options, {
      icon: options.icon || getDefaultIcon(options.type),
      title: options.title || '提示',
      showClose: false,
      cancelButton: false,
      keyboard: false,
      closeOnClickBackdrop: false,
    })
    return manager.createMsgBox(options)
  },

  /**
   * API - confirm
   */
  confirm(options) {
    options = _.assign(options, {
      icon: options.icon || getDefaultIcon(options.type),
      title: options.title || '提示',
    })
    return manager.createMsgBox(options)
  },
}
